import { api, getAuthHeaders } from "../axios";
import type { ServiceResponse } from "../axios";
import type { PaginationParams, SearchParams, SortingParams } from "../types";
import type { Firmware, FirmwareVersion } from "./types";

export const getFirmwares = async ({ page, per_page }: PaginationParams) => {
  const params: Record<string, string | number> = {
    page,
    per_page,
  };

  const { data } = await api.get<ServiceResponse<Firmware[]>>("/firmwares", {
    headers: getAuthHeaders(),
    params,
  });
  return data;
};

export const listFirmwareVersion = async ({
  firmwareId,
  page,
  per_page,
  search,
  order_by,
  sort_direction,
}: { firmwareId: number } & PaginationParams &
  SearchParams &
  SortingParams) => {
  const params: Record<string, string | number> = {
    page,
    per_page,
  };

  if (search) {
    params.search = search;
  }
  if (order_by) {
    params.order_by = order_by === "created_at" ? "uploaded_at" : order_by;
  }
  if (sort_direction) {
    params.sort_direction = sort_direction;
  }
  const { data } = await api.get<ServiceResponse<FirmwareVersion[]>>(
    `/firmwares/${firmwareId}/versions`,
    {
      headers: getAuthHeaders(),
      params,
    },
  );
  return data;
};
